<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="col-md-12">
        <div class="well-notify"></div>
    </div>
    <div class="well-title">
        <div class="col-md-12">Manage Customers</div>
    </div>
    <div>&nbsp;</div>
    <div class="col-md-12">
        <a class="back-link" routerLink="/report/arreport">Back to AR Report</a>
    </div>
    <div class="col-md-12 well-content">
        <div style="display: flex; gap: 8px; align-items: center">
            <nz-select [(ngModel)]="searchField" style="width: auto">
                @for (field of searchFields; track field) {
                    <nz-option [nzValue]="field.value" [nzLabel]="field.label"></nz-option>
                }
            </nz-select>
            <input
                nz-input
                [(ngModel)]="searchValue"
                placeholder="Enter search criteria..."
                style="width: 200px"
                (keydown.enter)="onSearch()" />
            <button nz-button nzType="primary" (click)="onSearch()">Search</button>
            <button nz-button (click)="clearSearch()">Reset</button>
            <button nz-button nz-dropdown class="pull-right" aria-label="Export" [nzDropdownMenu]="menu">
                <nz-icon nzType="file-excel" nzTheme="fill" />Export <nz-icon nzType="down" />
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu>
                    <li nz-menu-item>
                        <span (click)="onExport(false)" aria-label="Search Results">Search Results</span>
                    </li>
                    <li nz-menu-item>
                        <span (click)="onExport(true)" aria-label="All Customers"><strong>ALL Customers</strong></span>
                    </li>
                </ul>
            </nz-dropdown-menu>
        </div>
        <div style="margin-top: 10px; margin-bottom: 16px; display: flex; gap: 8px; align-items: center">
            <button nz-button class="btn-success" [routerLink]="['/report/arreport/customercreate']">
                New Customer
            </button>
        </div>
        <nz-table
            #customerTable
            [nzData]="customers.Data"
            nzShowSizeChanger
            nzTableLayout="fixed"
            nzBordered="true"
            [nzFrontPagination]="false"
            [nzLoading]="loading"
            [nzTotal]="total"
            [nzShowTotal]="totalTemplate"
            [nzPageSize]="pageSize"
            [nzPageSizeOptions]="pageSizeOptions"
            [nzPageIndex]="pageIndex"
            (nzQueryParams)="onQueryParamsChange($event)">
            <thead style="border: 1px solid black">
                <tr>
                    @for (column of columns; track column) {
                        <th
                            [nzShowSort]="column.compare"
                            [nzSortFn]="column.compare"
                            [nzColumnKey]="column.fieldName"
                            [nzSortOrder]="getSortOrder(column.fieldName)">
                            {{ column.title }}
                        </th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (data of customers.Data; track data.CustomerID) {
                    <tr>
                        <td class="scrollable-cell">{{ data.CustomerName }}</td>
                        <td class="scrollable-cell" style="text-align: center">{{ data.CustomerNumber }}</td>
                        <td class="scrollable-cell" style="text-align: center">{{ data.EmailAddress }}</td>
                        <td style="text-align: center">
                            @if (data.ShouldPrint) {
                                <span style="color: green" class="fa-solid fa-check"></span>
                            }
                        </td>
                        <td style="text-align: center">
                            @if (data.ShouldEmail) {
                                <span style="color: green" class="fa-solid fa-check"></span>
                            }
                        </td>
                        <td style="text-align: center">
                            <button
                                nz-button
                                [routerLink]="['/report/arreport/customeredit']"
                                [queryParams]="{id: data.CustomerID}"
                                class="btn btn-default">
                                <span class="fa-solid fa-pen-to-square"></span>
                            </button>
                        </td>
                    </tr>
                }
            </tbody>
        </nz-table>
        <ng-template #totalTemplate let-total>
            Showing items {{ pageIndex * pageSize - pageSize + 1 }}–{{
                pageIndex * pageSize > total ? total : pageIndex * pageSize
            }}
            out of {{ total }}
        </ng-template>
    </div>
</div>
